(function () {
  const DISCOUNT_CODE = 'LUCES20';
  const SALE_END = Date.parse('2026-06-19T00:00:00+02:00');
  const SESSION_KEY = 'lcn_auto_discount_applied';

  function isSaleActive() {
    return Date.now() < SALE_END;
  }

  function applyDiscount() {
    if (!isSaleActive()) {
      sessionStorage.removeItem(SESSION_KEY);
      return Promise.resolve(false);
    }

    if (sessionStorage.getItem(SESSION_KEY) === DISCOUNT_CODE) {
      return Promise.resolve(true);
    }

    return new Promise((resolve) => {
      const iframe = document.createElement('iframe');
      iframe.setAttribute('aria-hidden', 'true');
      iframe.setAttribute('tabindex', '-1');
      iframe.style.cssText = 'position:absolute;width:0;height:0;border:0;opacity:0;pointer-events:none';
      iframe.src = '/discount/' + encodeURIComponent(DISCOUNT_CODE);

      const cleanup = () => {
        iframe.remove();
        sessionStorage.setItem(SESSION_KEY, DISCOUNT_CODE);
        resolve(true);
      };

      iframe.addEventListener('load', cleanup, { once: true });
      iframe.addEventListener('error', () => {
        iframe.remove();
        resolve(false);
      }, { once: true });

      document.body.appendChild(iframe);
      window.setTimeout(cleanup, 2500);
    });
  }

  function refreshCartUi() {
    const cartDrawer = document.querySelector('cart-drawer');
    if (!cartDrawer || typeof cartDrawer.renderContents !== 'function' || !window.routes?.cart_url) return;

    fetch(`${window.routes.cart_url}?sections=cart-drawer,cart-icon-bubble`)
      .then((response) => response.json())
      .then((sections) => {
        if (!sections) return;
        cartDrawer.renderContents({ sections });
      })
      .catch(() => {});
  }

  function initAutoDiscount() {
    applyDiscount().then((applied) => {
      if (applied) refreshCartUi();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAutoDiscount);
  } else {
    initAutoDiscount();
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
      applyDiscount().then((applied) => {
        if (applied) refreshCartUi();
      });
    });
  }
})();
